import CommentContext from '@/context/apps/comment/CommentContext';
import React, { useContext } from 'react';

import { CommentContent } from '@/apis/comment/types';

import DropDownWithButton from '../dropdowns/DropDownWithButton';
import ReplyProfile from './ReplyProfile';

type Props = {
  data: CommentContent;
};

export default function ReplyView({ data }: Props) {
  const context = useContext(CommentContext);
  if (!context) {
    throw new Error('Cannot find CommentContext');
  }
  const { foreignUserIdx } = context;

  const isAuthor = foreignUserIdx === data.user.idx;

  return (
    <div className="flex flex-col items-start gap-1 bg-apps-coreGrayWhite px-5 py-4">
      <div className="flex items-center justify-between w-full gap-x-[12px]">
        {/* TODO: ReplyProfile 댓글 작성자 프로필 이미지 처리 */}
        <ReplyProfile
          profile={{ name: data.user.name }}
          updateDate={data.updated_utc_at}
          isAuthor={isAuthor}
        />

        <div className="-mb-1 -mr-2 -mt-1">
          <DropDownWithButton
            items={[
              {
                key: 'report',
                label: '신고',
                onClick: () => {
                  console.log('Report Content');
                },
                hasError: true,
              },
            ]}
          />
        </div>
      </div>
      <p className="ml-10 whitespace-pre-wrap break-words pb-2 text-[15px] font-normal leading-[150%]">
        {data.contents}
      </p>
    </div>
  );
}
